import { Typography } from "@common-ui/ui";

const limit = 15;

export default function checkTableValue(value) {
  if (value) {
    if (value.length > limit) {
      return <Typography>{`${value.slice(0, limit)}...`}</Typography>;
    } else {
      return <Typography>{value}</Typography>;
    }
  } else return <Typography>---</Typography>;
}
